"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _reactstrap = require("reactstrap");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FileUploader = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(FileUploader, _React$Component);

  var _super = _createSuper(FileUploader);

  function FileUploader(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, FileUploader);
    _this = _super.call(this, props);
    _this.state = {
      loaded: 0
    };
    _this.onChangeHandler = _this.onChangeHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onClickHandler = _this.onClickHandler.bind((0, _assertThisInitialized2["default"])(_this));
    _this.progressUpdater = {
      onUploadProgress: function (ProgressEvent) {
        var progress = parseInt(ProgressEvent.loaded / ProgressEvent.total * 100);
        this.setState({
          loaded: progress
        });
      }.bind((0, _assertThisInitialized2["default"])(_this))
    };
    return _this;
  }

  (0, _createClass2["default"])(FileUploader, [{
    key: "onChangeHandler",
    value: function onChangeHandler(event) {
      var file = event.target.files[0];
      var error = null;

      if (file) {
        if (!["application/pdf", "image/jpeg", "image/png", "image/tiff"].includes(file.type.toLowerCase())) {
          error = file.type.toLowerCase() + ' is not PDF, JPEG, PNG or TIFF ';
        }

        if (file.size > this.props.fileSizeTotalLimit) {
          error = "The file is too large";
        }

        if (error) {
          this.setState({
            error: error,
            loaded: 0
          });
        } else {
          this.onClickHandler(file);
        }
      }
    }
  }, {
    key: "onClickHandler",
    value: function onClickHandler(file) {
      var _this2 = this;

      this.props.onUploadStart();

      if (file) {
        this.setState({
          error: null,
          loaded: 1
        });
        var data = new FormData();
        data.append('upload', file);
        this.props.crmClient.post(this.props.pdfServiceUrl, data, this.progressUpdater).then(function (result) {
          if (_this2.props.onUploadComplete) {
            _this2.props.onUploadComplete(result.data);
          }

          _this2.setState({
            loaded: 0
          });
        })["catch"](function (error) {
          var message;

          if (error.response) {
            var e = error.response;
            var extractor = e.data && e.data.errors ? e.data.errors.extractor : "";
            message = "".concat(extractor);
          } else {
            message = "".concat(error);
          }

          this.setState({
            error: message
          });

          if (this.props.onUploadComplete) {
            this.props.onUploadComplete(null);
          }
        }.bind(this));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var files = this.props.files || [];
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactstrap.Row, {
        style: {
          paddingTop: "3px"
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
        sm: 2
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "file-upload-input"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn-xs btn-primary",
        title: "Upload Supporting Documentation"
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "fa fa-upload",
        "aria-hidden": "true"
      }), /*#__PURE__*/_react["default"].createElement("input", {
        type: "file",
        name: "upload_file",
        onChange: this.onChangeHandler
      }), this.props.buttonCaption))), /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
        sm: 10
      }, files.map(function (file, k) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: k,
          className: "nowrap"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: _this3.props.style,
          className: "nowrap"
        }, _this3.props.onRemoveFile ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("i", {
          className: "fa fa-trash file_remove text-danger",
          onClick: function onClick(e) {
            _this3.props.onRemoveFile(k);
          }
        }), "\xA0") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "\u2022"), /*#__PURE__*/_react["default"].createElement("strong", {
          className: "nowrap",
          title: file.date_created
        }, /*#__PURE__*/_react["default"].createElement("a", {
          style: {
            color: "#212529"
          },
          target: "_blank",
          href: file.upload
        }, file.file_name))));
      }), this.state.loaded ? /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
        sm: 12
      }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Progress, {
        value: this.state.loaded,
        label: "".concat(this.state.loaded, "%"),
        animated: true,
        striped: true,
        variant: "success",
        style: {
          marginBottom: "0px",
          width: "100%"
        }
      })) : null), /*#__PURE__*/_react["default"].createElement(_reactstrap.Col, {
        sm: 12
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: "red"
        }
      }, this.state.error ? "Error: ".concat(this.state.error) : null))));
    }
  }]);
  return FileUploader;
}(_react["default"].Component);

exports["default"] = FileUploader;
FileUploader.propTypes = {
  files: _propTypes["default"].array,
  fileSizeTotalLimit: _propTypes["default"].number,
  onUploadStart: _propTypes["default"].func,
  onUploadComplete: _propTypes["default"].func,
  onRemoveFile: _propTypes["default"].func,
  pdfServiceUrl: _propTypes["default"].string,
  crmClient: _propTypes["default"].func,
  buttonCaption: _propTypes["default"].string
};